// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maximized-chart {
    width: calc(100% - 30px);
    margin-left: 15px;
  }

  .maximize-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
  
  .maximize-icon.minimized {
    transform: rotate(180deg);
  }
  `, "",{"version":3,"sources":["webpack://./src/components/dashboard/TokenUsageHistogram.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".maximized-chart {\n    width: calc(100% - 30px);\n    margin-left: 15px;\n  }\n\n  .maximize-icon {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    cursor: pointer;\n  }\n  \n  .maximize-icon.minimized {\n    transform: rotate(180deg);\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
